import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAuthLoading, selectUser } from "../../redux/slices/authSlice";
import FullPageLoader from "../Common/FullPageLoader";
import { homeRouteForRole } from "../../constants/roles";

const resolveHomeRoute = (role) => homeRouteForRole(role) || "/";

const resolveLoadingLabel = (pathname = "") => {
  if (String(pathname).startsWith("/admin")) return "Loading admin portal...";
  if (String(pathname).startsWith("/promoter")) return "Loading promoter portal...";
  return "Loading...";
};

const authPending = ({ user, isLoading }) => {
  const hasToken = Boolean(localStorage.getItem("token"));
  // Only block with full-page loading when restoring an existing session.
  // Do not block public login page during fresh credential verification.
  return Boolean(hasToken && !user && isLoading);
};

export function ProtectedRoute({ allowedRoles = [], children }) {
  const location = useLocation();
  const user = useSelector(selectUser);
  const isLoading = useSelector(selectAuthLoading);
  const hasToken = Boolean(localStorage.getItem("token"));

  if (authPending({ user, isLoading })) {
    return <FullPageLoader label={resolveLoadingLabel(location.pathname)} />;
  }

  if (!hasToken || !user) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  if (
    Array.isArray(allowedRoles) &&
    allowedRoles.length > 0 &&
    !allowedRoles.includes(user.role)
  ) {
    return <Navigate to={resolveHomeRoute(user.role)} replace />;
  }

  return children;
}

export function PublicOnlyRoute({ children }) {
  const user = useSelector(selectUser);
  const isLoading = useSelector(selectAuthLoading);

  if (authPending({ user, isLoading })) {
    return <FullPageLoader label="Loading..." />;
  }

  if (user) {
    return <Navigate to={resolveHomeRoute(user.role)} replace />;
  }

  return children;
}
